import { configureStore, createSelector } from '@reduxjs/toolkit'
import deliverySlice from './stateReducers/deliverySlice';
import gunOptionSlice from './stateReducers/gunOptionSlice';
import globalSlice from './stateReducers/globalSlice';
import customerDetailsSlice from './stateReducers/customerDetailsSlice';
import extraItemsSlice from './stateReducers/extraItemsSlice';
import { createLogger } from 'redux-logger';
import invoiceSlice from './stateReducers/invoiceSlice';

const logger = createLogger();

const store = configureStore({
  reducer: {
      delivery: deliverySlice,
      gunOptions: gunOptionSlice,
      globals: globalSlice,
      customerDetails: customerDetailsSlice,
      extraItems: extraItemsSlice,
      invoiceDetails: invoiceSlice
  },
  middleware: [
    logger
  ],
  devTools: {
    trace: true,
    traceLimit: 25
  }
})

export default store
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

